import { render } from "./ImportIpra.vue?vue&type=template&id=c2bfe902"
import script from "./ImportIpra.vue?vue&type=script&lang=js"
export * from "./ImportIpra.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__